import React from 'react';
import classnames from 'classnames';

import './amazon-tag.scss';

export interface IProps {
    number: number;
}

export interface IState {
    
}

export class AmazonTag extends React.Component <IProps, IState> {    
    constructor(props: IProps){
        super(props);
    }

    public render(){
        return <div className="amazon-tag-root">
                    <svg width="101" height="18" viewBox="0 0 101 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 2C0 0.89543 0.895431 0 2 0H101L96.1373 7.9571C95.7461 8.59733 95.7461 9.40268 96.1373 10.0429L101 18H2C0.89543 18 0 17.1046 0 16V2Z" fill="#B75C22"/>
                        <text fill="white" y="13" x="5">#{this.props.number} New release </text> 
                    </svg>
                    <span>on amazon</span>
               </div>
    }
}